const TERMS_AND_CONDITIONS = {
  modal: {
    terms: 'Termos',
    anchors: {
      restitution: 'Valores acordados',
      taxCreditCard: 'Taxas de transações',
      perfomance: 'Indicadores',
      marketplace: 'Cobranças de comissão',
      cashback: 'Campanha Cashback',
      extension: 'Termo de Extensão',
    },
    error:
      'Estamos com uma indisponibilidade no nosso sistema para vizualizar as condições de operação. Aguarde e tente novamente mais tarde.',
  },
  accessibility: {
    buttons: {
      close: 'Voltar para a navegação do seu Zé',
    },
  },
  statusBadge: {
    scheduled: 'Agendado',
    active: 'Válido',
    expired: 'Expirado',
  },
  operationConditions: {
    remunerationPlan: 'Plano de Remuneração',
    remunerationPlanModalTitle: 'Condições de Operação com o Zé Delivery',
    minimumPerformanceIndicators: 'Indicadores de desempenho satisfatórios',
    valuesAgreedForRefund: 'Valores acordados para a restituição** do Zé',
    creditCardOnlineProcessingFees:
      'Transações via pagamento online com cartão de crédito',
    pixProcessingFees: 'Transações via pagamento online com PIX****',
    availabilityRate: 'Taxa de Disponibilidade',
    idealPortfolio: 'Portfólio Ideal',
    idealPortfolioExplanation:
      'Os produtos devem estar gelados, prontos para consumo. Acesse o link para entender mais sobre',
    productStockLink: 'como armazenar os produtos.',
    fillRate: 'Taxa de Aceitação',
    trackingRate: 'Taxa de Rastreio',
    pickingAndPackingRate: 'Liberação dos pedidos em até 10min',
    orderRate: 'Avaliação dos pedidos',
    markup: 'Markup mínimo',
    markupExplanation:
      'Você pode receber diretamente na sua conta corrente. Caso ainda receba pelo Duocard, entre em contato com o chat',
    pixValuesAgreedForRefundExplanation:
      '**As transferências serão realizadas sempre no dia seguinte (D+1) em relação aos pedidos',
    partnerDeliveryTax: 'Frete',
    operationalBonus: 'Incentivo operacional',
    operationalBonusExplanation:
      'Caso o pdv tenha "Avaliação de Clientes" na semana maior ou igual a 4.5',
    fixedFeePerSale: 'Taxa fixa por pedido aprovado',
    percentageFeePerSale: 'Taxa % por pedido no plano D+30***',
    anticipationFee: 'Taxa % por pedido no plano D+7***',
    fixedFeePerSalePix: 'Taxa fixa por pedido aprovado',
    transferFeePix: 'Taxa por transferência(PIX para sua conta)',
    depositFee: 'Taxa de depósito por transferência(TED)',
    close: 'Fechar',
    acceptTerms: 'Li e estou ciente das condições para participar da campanha',
    agreeText: 'Concordo',
    variableRemunerationTest: {
      onlinePayment: 'Cartão de crédito e Pix',
      pixProcessingFees: 'Transações via pagamento online com PIX**',
      valuesAgreedForRefund: 'Valores acordados para a restituição do Zé',
      minimumPerformanceIndicatorsExplanation:
        'Os indicadores de desempenho satisfatórios estão disponíveis no Termo de Condições de Operação, assinado via e-mail',
      valuesAgreedForRefundExplanation:
        'O incentivo operacional varia conforme o atingimento dos indicadores de desempenho satisfatórios descritos no Termo de Condições de Operação, assinados via e-mail',
      operationalBonus: 'até R$ 1,75',
      onlinePaymentRemunerationTest:
        'Atualmente, o serviço de pagamento online está disponível em algumas regiões do Brasil e sua ativação é opcional.',
      onlinePaymentRemunerationTest2:
        'Para habilitar, fale com a pessoa gerente de sua conta ou entre em contato pelo chat. Ao ativar o serviço de pagamento online, você deverá concordar com as condições e taxas abaixo:',
    },
    boxDeliveryTest: {
      valuesAgreedForRefund: 'Valores acordados para a restituição do Zé',
      pixProcessingFees: 'Transações via pagamento online com PIX**',
      valuesAgreedForRefundExplanation:
        'O frete varia conforme os valores descritos no Termo e Condições de Operação, assinado via e-mail',
      agreedValuesForRefundTest: 'R$ 0,00',
    },
    disclaimerCreditCard:
      '***As taxas acima são válidas para pedidos realizados com cartões das bandeiras',
    visaMaster: ' Visa e Mastercard',
    disclaimerCreditCard2:
      ', que representam 97% do volume de pedidos atualmente.',
    disclaimerCreditCard3:
      'Para pedidos realizados com cartões das demais bandeiras, as taxas são 2,20% no plano D+30 e 3,33% no plano D+7.',
  },
  conditionsNotificationBar: {
    toContinuePartnership:
      'Para continuar com a nossa parceria é necessário aceitar os ',
    toContinuePartnershipHexa:
      'Pra continuar com a parceria, você precisa aceitar os Termos e Condições. Leia com atenção antes de seguir.',
    generalTerms: 'Termos e Condições',
    readCarefully: ', leia atentamente.',
    readPlanAndTerms: 'Ler plano e termos',
    readPlanAndTermsHexa: 'Ler Termos e Condições',
    messageToOperationalUser:
      'Para continuar com a nossa parceria é necessário solicitar que o responsável pela loja aceite os ',
    messageToOperationalUserHexa:
      'Pra continuar com a parceria, você precisa solicitar que o responsável pela loja aceite os Termos e Condições.',
  },
  genericError: 'Houve um erro, tente novamente mais tarde.',
} as const

export default TERMS_AND_CONDITIONS
